import { connect } from 'react-redux';
import { resetCreatePto } from '../store/createOrder';
import {
  fetchPtoDetails,
  getPtoDetails,
  getPtoDetailsError,
  getPtoDetailsPending,
} from '../store/orderDetails';
import { setCurrentPtoDialogueOpen } from '../store/orderDrawer';

// eslint-disable-next-line import/no-cycle
import ViewPtoPanel from './ViewPanel';

const mapState = state => ({
  data: getPtoDetails(state),
  isLoading: getPtoDetailsPending(state),
  ptoDetailsError: getPtoDetailsError(state),
});

const mapDispatchToProps = {
  fetchPtoDetails,
  resetCreatePto,
  setCurrentPtoDialogueOpen,
};

export default connect(mapState, mapDispatchToProps)(ViewPtoPanel);
